<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Select Implementation Control
    Statement</h2>
  <mat-dialog-content *ngIf="rowGroupMetadata">
    <p-table [value]="implementationControlStatementSets"
             *ngIf="implementationControlStatementSets"
             rowGroupMode="subheader"
             dataKey="id">
      >
      <ng-template pTemplate="body" let-set let-expanded="expanded">
        <tr [pRowToggler]="set">
          <td style="width: 10em;">
            <a>
              <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            </a>
          </td>
          <td>{{ set.name }}</td>
          <td style="width: 10em;">
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="expandedrow" let-set let-rowIndex="rowIndex" let-expanded="expanded">
        <tr>
          <td colspan="3">
            <p-table [value]="set.implementationControlStatements"
                     [rows]="100"
                     [paginator]="false"
                     [style]="{'margin-top':'10px'}"
                     [resizableColumns]="true"
                     [reorderableColumns]="true"
                     dataKey="category"
                     #dashboardTable>

              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 5em;"></th>
                  <th>
                    Category
                  </th>
                  <th>
                    Name
                  </th>
                </tr>

              </ng-template>
              <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                           let-columns="columns">
                <tr class="ui-widget-header" *ngIf="rowGroupMetadata[item.implementationControlStatementSetId][item.category || ' '].index === rowIndex">
                  <td colspan="3">
                    <a href="#" [pRowToggler]="item">
                      <i
                        [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                      <span>{{ item.category }}</span>
                    </a>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="expandedrow" let-rowData let-expanded="expanded" let-columns="columns">
                <tr>
                  <td>
                    <span>
                      <i [ngClass]="rowData.open ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                         (click)="rowData.open = !rowData.open"></i>
                    </span>
                  </td>
                  <td (click)="selectImplementationControlStatement(rowData)">
                    {{ rowData.category }}
                  </td>
                  <td (click)="selectImplementationControlStatement(rowData)">
                    {{ rowData.name }}
                  </td>
                </tr>
                <tr *ngIf="rowData.open">
                  <td (click)="selectImplementationControlStatement(rowData)" colspan="3">
                    <div class="ql-editor"
                         [innerHTML]="addToken(rowData.text) | sanitizeHtml"></div>
                  </td>
                </tr>
              </ng-template>


            </p-table>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </mat-dialog-content>
</div>
